import roomService from "./api/room.service";
import reservationService from "./api/reservation.service";
import teacherService from "./api/teacher.service";
import subjectService from "./api/subject.service";
import classService from "./api/class.service";

const bszService = {
  ...roomService,
  ...reservationService,
  ...teacherService,
  ...subjectService,
  ...classService,
};

export default bszService;
